export const attachmentPolicyInformationBlockedAccess = "h7QBv";
export default {attachmentPolicyInformationBlockedAccess};